var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyAccountAddProvider(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22287",
    "data-name": "Group 22287",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.389,
    height: 17.385,
    viewBox: "0 0 17.389 17.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9592",
    "data-name": "Rectangle 9592",
    width: 17.389,
    height: 17.385,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22287-2",
    "data-name": "Group 22287",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16234",
    "data-name": "Path 16234",
    d: "M120,215.128a1.321,1.321,0,0,0-.355-.081,4.53,4.53,0,0,1-1.2-.538,27.142,27.142,0,0,1-5.754-4.4c-.024-.024-.044-.051-.065-.076-.044-.083.023-.127.068-.172q1.322-1.326,2.648-2.648c.038-.038.074-.091.142-.069a20.013,20.013,0,0,0,1.528,1.315,13.911,13.911,0,0,0,1.25.841.5.5,0,0,0,.662-.082c.143-.136.283-.276.424-.414.072.016.111.075.159.122q2.021,2.019,4.039,4.039c.047.047.106.086.121.159-.435.443-.855.9-1.327,1.306a2.861,2.861,0,0,1-1.511.662c-.023,0-.044.007-.052.033Z",
    transform: "translate(-107.505 -197.743)",
    fill: "#e9343c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16235",
    "data-name": "Path 16235",
    d: "M7.982,35.165c-.046.041-.1.08-.139.123q-1.3,1.3-2.592,2.592c-.051.051-.119.091-.127.174A26.793,26.793,0,0,1,1.058,32.93c-.2-.333-.392-.673-.589-1.009a3.391,3.391,0,0,1-.43-1.151c-.005-.031,0-.07-.039-.085v-.407a.347.347,0,0,0,0-.238v-.2a.607.607,0,0,0,.082-.282,3.012,3.012,0,0,1,.784-1.435c.374-.383.757-.756,1.136-1.134a.668.668,0,0,1,.147.139C3.53,28.5,4.9,29.887,6.29,31.258a.121.121,0,0,1,.028.042l-.4.41a.509.509,0,0,0-.081.7,14.218,14.218,0,0,0,2,2.593c.051.053.1.107.149.161",
    transform: "translate(0 -25.761)",
    fill: "#f16338"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16236",
    "data-name": "Path 16236",
    d: "M48.428,6.793c-.076-.006-.115-.068-.162-.115Q46.246,4.66,44.228,2.64c-.047-.047-.109-.084-.116-.161.256-.255.5-.521.769-.763a1.474,1.474,0,0,1,2.02,0Q48.075,2.829,49.192,4a1.482,1.482,0,0,1,0,2.022c-.242.268-.509.513-.765.768",
    transform: "translate(-42.11 -1.255)",
    fill: "#e9343c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16237",
    "data-name": "Path 16237",
    d: "M265.386,223.764c-.039-.032-.08-.061-.116-.1q-2.054-2.053-4.107-4.107c-.035-.035-.064-.077-.1-.116.247-.247.488-.5.744-.741a1.489,1.489,0,0,1,2.06-.01q1.158,1.107,2.265,2.266a1.485,1.485,0,0,1,0,2.047c-.239.263-.5.506-.75.758",
    transform: "translate(-249.221 -208.381)",
    fill: "#b3093a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16238",
    "data-name": "Path 16238",
    d: "M288.4.143a4.052,4.052,0,0,1,3,1.235,4.123,4.123,0,0,1,1.239,3.35,4.245,4.245,0,0,1-3.5,3.833,2.916,2.916,0,0,1-.74.058.145.145,0,0,1-.046-.1,5.605,5.605,0,0,1,.013-.868c.037-.084.115-.08.188-.086a3.275,3.275,0,0,0,1.771-.657,3.1,3.1,0,0,0,1.224-2.166,3.076,3.076,0,0,0-.888-2.586,3.051,3.051,0,0,0-1.882-.923c-.138-.017-.3.024-.41-.108a5.232,5.232,0,0,1-.016-.872A.145.145,0,0,1,288.4.143",
    transform: "translate(-275.262 -0.136)",
    fill: "#7cb62e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16239",
    "data-name": "Path 16239",
    d: "M200.256,7.471q0,.506,0,1.013a4.241,4.241,0,0,1-.608-8.439,2.48,2.48,0,0,1,.608-.038V1.02l-.019.019a7.053,7.053,0,0,0-.864.152,3.134,3.134,0,0,0-1.871,1.47,3.013,3.013,0,0,0-.234,2.661A3.122,3.122,0,0,0,199.82,7.4a3.389,3.389,0,0,1,.418.056l.019.019",
    transform: "translate(-187.116 0)",
    fill: "#b5ca1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16240",
    "data-name": "Path 16240",
    d: "M288.25,22.47a3.225,3.225,0,0,1,0,6.451h0a.135.135,0,0,1-.039-.074,3.806,3.806,0,0,1,.018-.928.252.252,0,0,1,.143-.084.477.477,0,0,0,.338-.494q0-.424,0-.848c0-.328.01-.337.347-.338.283,0,.566,0,.848,0a.478.478,0,0,0,.381-.155.432.432,0,0,0,.084-.474.438.438,0,0,0-.407-.284c-.271-.014-.543,0-.814,0h-.153c-.257,0-.283-.028-.285-.281,0-.277-.007-.554,0-.831a.517.517,0,0,0-.382-.583.177.177,0,0,1-.1-.064,2.366,2.366,0,0,1,.019-1.006Z",
    transform: "translate(-275.11 -21.45)",
    fill: "#4c9634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16241",
    "data-name": "Path 16241",
    d: "M221.711,22.47v1.013l-.018.024a.5.5,0,0,1-.121.06.492.492,0,0,0-.321.491c0,.3,0,.6,0,.9,0,.254-.026.277-.285.279s-.543,0-.814,0a1.5,1.5,0,0,0-.153,0,.479.479,0,0,0-.442.456.471.471,0,0,0,.442.454c.248.017.5,0,.746.006h.237c.238,0,.266.029.268.262s.017.488,0,.729a.626.626,0,0,0,.446.738l.018.024q0,.506,0,1.013a3.226,3.226,0,1,1,0-6.451",
    transform: "translate(-208.571 -21.45)",
    fill: "#7cb62e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountAddProvider);
export default __webpack_public_path__ + "static/media/my-account-add-provider.698d60638d773a01c32ae8f079eaa7f1.svg";
export { ForwardRef as ReactComponent };